import { render } from "./CommerceProductShow.vue?vue&type=template&id=29819b54&scoped=true"
import script from "./CommerceProductShow.vue?vue&type=script&lang=js"
export * from "./CommerceProductShow.vue?vue&type=script&lang=js"

import "./CommerceProductShow.vue?vue&type=style&index=0&id=29819b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29819b54"]])

export default __exports__